// Module
var code = "export default __webpack_public_path__ + \"postMock.html\";";
// Exports
module.exports = code;